import script from "./score-item-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./score-item-text.vue?vue&type=script&lang=ts&setup=true"

import "./score-item-text.vue?vue&type=style&index=0&id=4f06feca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f06feca"]])

export default __exports__